import { PdfAnnotation } from './pdf-annotation.model';

export interface AnnotationData {
    annotations: PdfAnnotation[];
    error: string | null;
}

// Una entrada desconocida nunca autoriza reemplazar el original por un estado vacío.
export function readAnnotationData(input: any): AnnotationData {
    const invalid = { annotations: [], error: 'No se han podido recuperar las anotaciones. La edición y el guardado están bloqueados.' };
    try {
        let data = input;
        if (typeof data === 'string') {
            if (!data.trim()) { return { annotations: [], error: null }; }
            data = JSON.parse(data);
        }
        if (data == null || (typeof data === 'object' && !Array.isArray(data) && !Object.keys(data).length)) {
            return { annotations: [], error: null };
        }
        if (!Array.isArray(data) && (!data || (data.version !== undefined && data.version !== 1))) { return invalid; }
        const annotations = Array.isArray(data) ? data : data.annotations;
        if (!Array.isArray(annotations)) { return invalid; }
        const ids = new Set<string>();
        const finite = (value: any) => typeof value === 'number' && Number.isFinite(value);
        for (const item of annotations) {
            if (!item || typeof item.id !== 'string' || !item.id || ids.has(item.id) ||
                !Number.isInteger(item.page) || item.page < 1) { return invalid; }
            ids.add(item.id);
            if (item.type === 'ink') {
                if (!Array.isArray(item.points) || !item.points.every(point => point && finite(point.x) && finite(point.y))) {
                    return invalid;
                }
            } else {
                if (!finite(item.x) || !finite(item.y)) { return invalid; }
                if (item.type === 'highlight') {
                    if (!finite(item.w) || !finite(item.h)) { return invalid; }
                } else if (item.type === 'note' || item.type === 'freeText') {
                    if (typeof item.text !== 'string') { return invalid; }
                    if (item.type === 'freeText' && (!finite(item.width) || !finite(item.height) || !finite(item.fontSize))) {
                        return invalid;
                    }
                } else { return invalid; }
            }
        }
        return { annotations, error: null };
    } catch (_) {
        // No registrar JSON, notas ni el error del parser (puede contener el texto recibido).
        return invalid;
    }
}
